<template>
  <button type="button" @click="handleCopy">
    <span v-if="$slots.default" class="mr-1">
      <slot />
    </span>
    <Transition name="copy-feedback" mode="out-in">
      <Check v-if="copied" key="check" class="inline-icon text-green-600" />
      <Copy v-else key="copy" class="inline-icon" />
    </Transition>
  </button>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue';
import { Check, Copy } from 'lucide-vue-next';
import { copyToClipboard } from '@/utils/clipboard';

const props = withDefaults(
  defineProps<{
    text: string | number;
    copiedDuration?: number;
  }>(),
  {
    copiedDuration: 1200,
  },
);

const copied = ref(false);
let resetTimeout: number | undefined;

async function handleCopy(): Promise<void> {
  await copyToClipboard(String(props.text));
  copied.value = true;

  if (resetTimeout) window.clearTimeout(resetTimeout);
  resetTimeout = window.setTimeout(() => {
    copied.value = false;
  }, props.copiedDuration);
}

onBeforeUnmount(() => {
  if (resetTimeout) window.clearTimeout(resetTimeout);
});
</script>

<style scoped>
.copy-feedback-enter-active,
.copy-feedback-leave-active {
  transition:
    opacity 150ms ease,
    transform 150ms ease;
}

.copy-feedback-enter-from,
.copy-feedback-leave-to {
  opacity: 0;
  transform: scale(0.65);
}

.copy-feedback-enter-to,
.copy-feedback-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>
